import { useState, useMemo } from 'react';
import useInput from '../../../../../../../../hooks/useInput';
import { unique } from '../../../../../../../../helpers/utils';

const useTournamentFilters = (tournaments) => {
  const [selectedTop, onChangeSelectedTop] = useState('allTypes');
  const [search, onChangeSearch] = useInput('');
  
  const states = useMemo(() => unique(tournaments.map(t => t.tournamentState)), [tournaments]);
  const [selectedState, onChangeSelectedState] = useState('allStates');
  
  const categories = useMemo(() => unique(tournaments.map(t =>  t.tournamentType)),[tournaments]);
  const [selectedCategories, onChangeSelectedCategories] = useState('allCategories');

  return {
    selectedTop, onChangeSelectedTop, 
    search, onChangeSearch,
    states, selectedState, onChangeSelectedState,
  categories, selectedCategories,
    onChangeSelectedCategories,
  };
}

export default useTournamentFilters;